import React, { useState, useEffect } from 'react';
import {
    ModalContainer,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalFormLabel,
    ModalForm,
    ModalTextArea,
    ModalCloseButton,
    ModalButton,
    RemoveModalOverlay
} from './RemoveModalElements';

const RemoveModal = ({ isOpen, onClose, onDelete, story }) => {

    if (!isOpen) return null;

    return (
        <RemoveModalOverlay>
            <ModalContainer>
                <ModalHeader>Are you sure you want to delete?</ModalHeader>
                <ModalFooter>
                    <ModalCloseButton onClick={onClose}>Cancel</ModalCloseButton>
                    <ModalButton onClick={(e) => onDelete(e, story)}>Delete</ModalButton>
                </ModalFooter>
            </ModalContainer>
        </RemoveModalOverlay>
    );
};


export default RemoveModal;
